//
// TableRows.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./AbstractTableRow";
import "./TableLabel";

var TableRows = createModule("BIRD::TableRows", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::AbstractTableRow"], EventDispatcher, [
    ,
    {
        styleClass: 7,
        rows: [1],
        labels: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default TableRows;
